import { createApp , App } from "vue";
import AppContainer from "./App.vue";
import router from "./router";
import Quasar from 'quasar/src/vue-plugin.js';;
import quasarUserOptions from "./quasar-user-options";
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

declare const Buffer: any;

const firebaseConfig = {
	apiKey: "AIzaSyB8nW3UnmTSE0xkOYbNG2CPLbKwlk_rSxE",
	authDomain: "chozeapp-11a78.firebaseapp.com",
	projectId: "chozeapp-11a78",
	storageBucket: "chozeapp-11a78.appspot.com",
	messagingSenderId: "17470412700",
	appId: "1:17470412700:web:afa1750e0be9a69f6e5a59",
};
initializeApp(firebaseConfig);

let app: App;

getAuth().onAuthStateChanged(function (user) {
	if (!app) {
		app = createApp(AppContainer);
		app.use(Quasar, quasarUserOptions);
		app.use(router);
		app.mount("#app");
	}
});
